import React, { useRef, useEffect  } from 'react';
import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import "../assets/styles/contact.scss"
import Header from "../components/Header";
import searchIcon from "../assets/images/search-icon.svg";
import { useState } from "react";
import FaqList from "../components/FaqList";
import Footer from "../components/Footer";
import { ReactComponent as FaqIcon } from '../assets/images/faq-icon.svg';
import { ReactComponent as OnlineChatIcon } from '../assets/images/online-chat-icon.svg';
import { FaComment } from "react-icons/fa";
import { useLocation } from "react-router-dom";

const MapCenterController = ({ center, zoom }) => {
  const map = useMap();
  const lastCenter = useRef(null);

  useEffect(() => {
    if (center && center.lat && center.lon) {
      const isSame =
        lastCenter.current &&
        lastCenter.current.lat === center.lat &&
        lastCenter.current.lon === center.lon;

      if (!isSame) {
        map.setView([center.lat, center.lon], zoom || 13, {
          animate: true,
          duration: 0.5,
          easeLinearity: 0.25,
        });
        lastCenter.current = center;
      }
    }
  }, [map, center, zoom]);

  return null;
};

const AnyReactComponent = ({ text }) => <div>{text}</div>;

const toCallablePhone = (phone) => {
  const latinPhone = String(phone || '')
    .replace(/[\u06F0-\u06F9]/g, digit => String(digit.charCodeAt(0) - 0x06F0))
    .replace(/[\u0660-\u0669]/g, digit => String(digit.charCodeAt(0) - 0x0660));
  const digits = latinPhone.replace(/\D/g, '');

  return latinPhone.trim().startsWith('+') ? `+${digits}` : digits;
};

const PhoneNumbers = ({ value }) => {
  const parts = String(value || '').split(/([،,/])/u);
  const phoneItems = [];

  for (let index = 0; index < parts.length; index += 2) {
    const displayPhone = (parts[index] || '').trim();
    if (!displayPhone) continue;

    phoneItems.push({
      displayPhone,
      separator: parts[index + 1] || '',
      callablePhone: toCallablePhone(displayPhone),
    });
  }

  return (
    <span className="phone-numbers" dir="ltr">
      {phoneItems.map(({ displayPhone, separator, callablePhone }, index) => (
        <span className="phone-number-item" key={`${displayPhone}-${index}`}>
          {callablePhone ? (
            <a href={`tel:${callablePhone}`} aria-label={`تماس با ${displayPhone}`}>
              {displayPhone}
            </a>
          ) : (
            <span>{displayPhone}</span>
          )}
          {separator && <span className="phone-separator">{separator}</span>}
        </span>
      ))}
    </span>
  );
};

function Contact() {
    const [activeItems, setActiveItems] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [copyMessageVisible, setCopyMessageVisible] = useState(false);
    
    // --- Leaflet marker icon fix for CRA asset paths
    const DefaultIcon = new L.Icon({
      iconUrl: require('leaflet/dist/images/marker-icon.png'),
      iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
      shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    L.Marker.prototype.options.icon = DefaultIcon;

    // Helpers to parse lat/lon from existing Google Maps URLs
    const parseLatLonFromUrl = (url) => {
      try {
        let m = url.match(/!2d(-?[0-9.]+)!3d(-?[0-9.]+)/);
        if (m) return { lat: parseFloat(m[2]), lon: parseFloat(m[1]) };
        m = url.match(/!3d(-?[0-9.]+)!4d(-?[0-9.]+)/);
        if (m) return { lat: parseFloat(m[1]), lon: parseFloat(m[2]) };
        m = url.match(/[?&](?:query|q)=(-?[0-9.]+),(-?[0-9.]+)/);
        if (m) return { lat: parseFloat(m[1]), lon: parseFloat(m[2]) };
      } catch (e) {}
      return null;
    };

    const centralOffice = { lat: 35.65753927185436, lon: 51.412704539405176 };
    
    // تغییر: حذف departmentMap state و استفاده از mapCenter
    const [mapCenter, setMapCenter] = useState({ lat: 32.4279, lon: 53.6880 }); // مرکز ایران
    const [mapZoom, setMapZoom] = useState(5);
    const [visibleCount, setVisibleCount] = useState(6);

    const targetRef = useRef(null);
    const mapRef = useRef(null);
    const [goftinoReady, setGoftinoReady] = useState(false);
    const location = useLocation();

    const scrollToTarget = () => {
      if (targetRef.current) {
        targetRef.current.scrollIntoView({ behavior: 'smooth' });
      }
    };

    const isMobile = window.innerWidth <= 767;
    const [departments, setDepartments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
      fetch('/api/branches.php')
        .then(res => res.json())
        .then(response => {
          if (response.success && Array.isArray(response.data)) {
            // تطبیق فیلدها: location_url -> location, work_time -> workTime
            const mapped = response.data.map(item => ({
              name: item.name,
              address: item.address,
              location: item.location_url,
              phone: item.phone,
              workTime: item.work_time
            }));
            // مرتب‌سازی بر اساس حروف الفبای فارسی
            const faCollator = new Intl.Collator('fa');
            mapped.sort((a, b) => faCollator.compare(a.name || '', b.name || ''));
            setDepartments(mapped);
          } else {
            console.error('Invalid API response:', response);
            setDepartments([]);
          }
          setLoading(false);
        })
        .catch(err => {
          console.error('Failed to load departments:', err);
          setLoading(false);
        });
    }, []);

const faqItems = [
        {
          question: 'سرویس ارسال بار باربری وطن به کدام شهرهای ایران ارسال بار دارد؟',
          answer: `باربری وطن به بیش از ۳۰۰ شهر ایران، ارسال بار دارد. 
      برای یافتن نزدیک‌ترین نمایندگی به مقصد خود، از قسمت «یافتن نمایندگی» شهر مورد نظر خود را انتخاب کنید.`,
          button: 'یافتن نمایندگی',
          link: '/contact#department-map',
        },
        {
          question: 'برای ارسال بارم با باربری وطن باید چه کنم؟',
          answer: `با شماره زیر با ما تماس بگیرید تا در سریع‌ترین زمان، بار شما را از هر نقطه در تهران تحویل بگیریم. 
      همچنین می‌توانید با مراجعه به ترمینال مرکزی باربری وطن در تهران به آدرس زیر، بار خود را به ما تحویل دهید.`,
          button: 'تماس با ما',
          link: '/contact',
          hasSpecialBoxes: true,
          address: 'آدرس باربری وطن: تهران، خیابان شوش، ابتدای خیابان رجایی، پلاک ۷۶۳',
          phone: 'تلفن باربری وطن: ۵۷۵۲۳-۰۲۱'
        },
        {
          question: 'آیا باری که توسط حمل‌ونقل وطن جابجا می‌شود، بیمه می‌شود؟',
          answer: `بار شما، به محض تحویل به ما و صدور رسید، تحت پوشش بیمه قرار گرفته و پرداخت کامل خسارات احتمالی به میزان ارزش اعلامی انجام می‌شود.
      
      بیمه تکمیلی ویژه وطن، خسارات احتمالی در تمامی ابعاد و به‌صورت تمام ریسک را علاوه بر پوشش بیمه‌ای توسط «بیمه ایران»، از محل «صندوق تامین خسارات وطن» جبران خواهد کرد.
      
      همچنین به‌منظور تسریع امور بیمه‌ای، با حذف مراحل بروکراسی، خسارات وارده، حداکثر به‌مدت یک‌ماه از زمان ارائه اسناد و مدارک توسط مشتریان گرامی پرداخت می‌‌گردد.
      
      برای اطلاع از جزییات پوشش بیمه تکمیلی و انواع آن، به صفحه پشتیبانی مراجعه کنید.`,
          button: 'پشتیبانی',
          link: '/contact',
        },
      //   {
      //     question: 'سرویس ارسال بار با وطن اکسپرس چه تفاوتی با سرویس ارسال بار با باربری وطن دارد؟',
      //     answer: `باربری وطن به بیش از ۳۰۰ شهر ایران، ارسال بار دارد. 
      // برای یافتن نزدیک‌ترین نمایندگی به مقصد خود، از قسمت «یافتن نمایندگی» شهر مورد نظر خود را انتخاب کنید.`,
      //     button: 'یافتن نمایندگی',
      //     link: '/contact#department-map',
      //   },
        {
          question: 'از کجا می‌توانم وضعیت و موقعیت بار ارسال شده‌ام با باربری وطن را پیگیری کنم؟',
          answer: `شما می‌توانید از طریق سامانه رهگیری بار باربری وطن، بدون نیاز به تماس با ما، از طریق جستجوی شماره رسید، از وضعیت بار خود آگاه شوید.
همچنین می‌توانید از طریق شماره زیر، با ما تماس گرفته و از وضعیت بار خود آگاه شوید.`,
          button: 'رهگیری بار',
          link: null,
          action: 'openChat',
          hasSpecialBoxes: true,
          phone: 'تلفن باربری وطن: ۵۷۵۲۳-۰۲۱'
        },
      ];
      

      const handleToggleFAQ = (index) => {
        setActiveItems((prevActiveItems) =>
          prevActiveItems.includes(index) ? [] : [index]
        );
      };

      const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
      };

    // یکسان‌سازی متن برای جستجو: حذف فاصله/نیم‌فاصله و یکسان‌سازی حروف فارسی/عربی
    const normalizeText = (str) =>
      (str || '')
        .toLowerCase()
        .replace(/[\u200b-\u200f\u202a-\u202e\s]/g, '') // فاصله، نیم‌فاصله و کاراکترهای جهت‌دهی
        .replace(/ي/g, 'ی')   // ی عربی → ی فارسی
        .replace(/ك/g, 'ک')   // ک عربی → ک فارسی
        .replace(/[أإآ]/g, 'ا'); // انواع الف → الف ساده

    const normalizedSearch = normalizeText(searchTerm);
    const filteredDepartments = departments.filter(dep =>
        normalizeText(dep.name).includes(normalizedSearch)
    );

    useEffect(() => {
      window.scrollTo(0, 0);
      const handleGoftinoReady = () => {
        setGoftinoReady(true);
      };
  
      window.addEventListener('goftino_ready', handleGoftinoReady);
  
      return () => {
        window.removeEventListener('goftino_ready', handleGoftinoReady);
      };
    }, []);

    // تغییر: تابع برای تغییر center نقشه
    const handleMapViewChange = (lat, lon, zoom = 13) => {
      setMapCenter({ lat, lon });
      setMapZoom(zoom);
    };

    // Handle search results and update map accordingly
    useEffect(() => {
      const MIN_SEARCH_LENGTH = 3;
      if (searchTerm.length >= MIN_SEARCH_LENGTH && filteredDepartments.length > 0) {
        // گرفتن مختصات همه نتایج
        const coords = filteredDepartments
          .map(dep => parseLatLonFromUrl(dep.location))
          .filter(Boolean);
    
        if (coords.length === 1) {
          // اگر فقط 1 نتیجه بود همون setView
          handleMapViewChange(coords[0].lat, coords[0].lon, 13);
        } else if (coords.length > 1 && mapRef.current) {
          // اگر چندتا نتیجه بود → fitBounds
          const bounds = coords.map(c => [c.lat, c.lon]);
          mapRef.current.fitBounds(bounds, { padding: [50, 50] });
        }
      }
    }, [searchTerm, filteredDepartments]);

    // Scroll to anchors like #department-map when arriving with a hash
    useEffect(() => {
      if (location.hash) {
        const targetId = location.hash.replace('#', '');
        setTimeout(() => {
          const el = document.getElementById(targetId);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
        }, 120);
      }
    }, [location]);

    useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const cityParam = params.get('city');
    
       if (cityParam) {
        const match = departments.find(dep =>
          dep.name.toLowerCase().includes(cityParam.toLowerCase())
        );
        if (match) {
          const parsed = parseLatLonFromUrl(match.location);
          if (parsed) {
            handleMapViewChange(parsed.lat, parsed.lon, 13);
          }
          setSearchTerm(cityParam);
        }
        
        setTimeout(() => {
          const target = document.getElementById('department-map');
          if (target) {
            target.scrollIntoView({ behavior: 'smooth' });
          }
        }, 400);
      }
    }, []);

    const openChat = () => {
        window.Goftino.open();
    };

    // نمایش ساعت کاری: همیشه با «شنبه تا پنجشنبه» شروع می‌شود
    const formatWorkTime = (workTime) => {
      const days = 'شنبه تا پنجشنبه';
      const time = (workTime || '').trim();
      return time ? `${days}، ${time}` : days;
    };

    const copyDepartmentInfo = async (department) => {
      const departmentInfo = [
        `آدرس: ${department.address || ''}`,
        `تلفن: \u2066${department.phone || ''}\u2069`,
        `ساعت کاری: ${formatWorkTime(department.workTime)}`,
        `لوکیشن: ${department.location || ''}`,
      ].join('\n');

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(departmentInfo);
        } else {
          const textArea = document.createElement('textarea');
          textArea.value = departmentInfo;
          textArea.setAttribute('readonly', '');
          textArea.style.position = 'fixed';
          textArea.style.opacity = '0';
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
        }

        setCopyMessageVisible(true);
        window.setTimeout(() => setCopyMessageVisible(false), 1800);
      } catch (error) {
        console.error('Failed to copy department information:', error);
      }
    };

    const getMapLink = (embedUrl) => {
      try {
        const match = embedUrl.match(/!2d(.*?)!3d(.*?)(!|$)/);
        if (match) {
          const lng = match[1];
          const lat = match[2];
    
          const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    
          const isAndroid = /android/i.test(userAgent);
          const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    
          if (isAndroid) {
            return `geo:0,0?q=${lat},${lng}`;
          } else if (isIOS) {
            return `maps://maps.apple.com/?q=${lat},${lng}`;
          } else {
            return `https://www.google.com/maps/search/?api=1&query=${lat},${lng}`;
          }
        }
      } catch (e) {
        return embedUrl;
      }
    };
    
  return (
       <div className="contact-container">
        <Header activePage="contact"/>
    <div className="main-container">

       <div className="contact-cards-container">
        <div className="left-cards">
            <div className="contact-desc-card">
                <img src={require('../assets/images/contact-desc.png')} alt="Call Center"/>
                <div className="texts">
                    <h3>تماس با حمل‌ونقل وطن</h3>
                    {/* <p>
                    شما می‌توانید بدون انتظار در صف پاسخ‌گویی، از <span onClick={openChat}>چت آنلاین</span> برای صرفه‌جویی در وقت خود استفاده کنید. همچنین می‌توانید پاسخ پرسش‌های خود را در بخش <span onClick={scrollToTarget}>پرسش‌های پرتکرار</span> پیدا  کنید.
                    </p> */}
                    <p>
                    شما می‌توانید پاسخ پرسش‌های خود را در بخش <span onClick={scrollToTarget}>پرسش‌های پرتکرار </span> پیدا کنید. همچنین می‌توانید بدون انتظار در صف پاسخ‌گویی تلفنی، از  <span onClick={openChat}>چت آنلاین</span> برای صرفه‌جویی در وقت خود استفاده کنید.
                    </p>
                </div>
            </div>

            <div className="contact-info-container">
                <div className="faq-chat-container">
                    <div onClick={scrollToTarget} className="faq-chat-card-first">
                        <h6>پرسش‌های پرتکرار مشتریان</h6>
                        <div className="icon-container">
                        <FaqIcon className="faq-icon"/>
                       </div>                        
                    </div>

                    <div onClick={openChat}  className="faq-chat-card">
                        <h6>درخواست همکاری</h6>
                        <div className="icon-container">
                        <OnlineChatIcon className="faq-icon"/>
                       </div>                        
                    </div>

                    <div onClick={openChat} className="faq-chat-card">
                        <h6>درخواست نمایندگی</h6>
                        <div className="icon-container">
                        <OnlineChatIcon className="faq-icon"/>
                       </div>                        
                    </div>
                </div>
                <div className="info-card">
                    <div className="info-list">
                    <a href='tel:02157523' className="info-item">
                        <span style={{direction:'ltr'}}>۰۲۱ - ۵۷۵۲۳</span>
                        <span>شماره تماس:</span>
                    </a>

                    <div className="info-item">
                        <a>۰۲۱ - ۵۵ ۱۸ ۷۳ ۷۳</a>
                        <span>شماره فکس:</span>
                    </div>

                    <a href='mailto:info@vatantransport.com' className="info-item">
                        <span>info@vatantransport.com</span>
                        <span>پست الکترونیکی:</span>
                    </a>

                    <div className="info-item">
                        <span>شنبه تا پنج‌شنبه، ۹ تا ۱۹</span>
                        <span>ساعت پاسخ‌گویی:</span>
                    </div>

                    <div className="info-item red-item">
                        <span>هر روز هفته، ۲۴ ساعته</span>
                        <span>ساعت کاری باربری:</span>
                    </div>
                </div>
                    </div>
            </div>
        </div>

        <div className="right-cards">
          
        <div className='address-map'
          style={{ width: '100%', height: '80%' }}
        >
          <MapContainer center={[centralOffice.lat, centralOffice.lon]} zoom={15} minZoom={5} scrollWheelZoom style={{ width: '100%', height: '100%' }}>
            <TileLayer
              attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
            />
            <Marker 
              position={[centralOffice.lat, centralOffice.lon]} 
              eventHandlers={{
                click: () => {
                  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                  const isAndroid = /android/i.test(userAgent);
                  const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
                  
                  if (isAndroid) {
                    window.location.href = `geo:${centralOffice.lat},${centralOffice.lon}`;
                  } else if (isIOS) {
                    window.location.href = `https://maps.apple.com/?q=${centralOffice.lat},${centralOffice.lon}`;
                  } else {
                    window.open(`https://www.google.com/maps?q=${centralOffice.lat},${centralOffice.lon}`, '_blank', 'noopener,noreferrer');
                  }
                }
              }}
            />
          </MapContainer>
        </div>

        <div 
          className="address-card"
          style={{ cursor: 'pointer' }}
          onClick={() => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const isAndroid = /android/i.test(userAgent);
            const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
            
            if (isAndroid) {
              window.location.href = `geo:${centralOffice.lat},${centralOffice.lon}`;
            } else if (isIOS) {
              window.location.href = `maps://maps.apple.com/?q=${centralOffice.lat},${centralOffice.lon}`;
            } else {
              window.open(`https://www.google.com/maps?q=${centralOffice.lat},${centralOffice.lon}`, '_blank', 'noopener,noreferrer');
            }
          }}
        >
            <p>نشانی ترمینال مرکزی: تهران، خیابان شوش، ابتدای خیابان رجایی، پلاک ۷۶۳. کد پستی: ۱۱۸۸۶۳۵۱۱۱</p>
        </div>
        </div>

    
       </div>

       <div id="department-map"></div>
       <div className="department-container">
        <h4>شعب و نمایندگی‌ها</h4>
        <div className="department-content">

            <div className="left-content">
            <MapContainer 
              ref={mapRef}
              center={[32.4279, 53.6880]} // مرکز ایران - ثابت برای initial render
              zoom={5}
              minZoom={5}
              maxZoom={18}
              scrollWheelZoom 
              style={{ width: '100%', height: '100%' }}
              maxBounds={[
                [20, 40], // Southwest bounds (south, west)
                [45, 70]  // Northeast bounds (north, east)
              ]}
              maxBoundsViscosity={1.0}
            >
              {/* اضافه کردن MapCenterController */}
              <MapCenterController center={mapCenter} zoom={mapZoom} />
              
              <TileLayer
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
              {departments.map((dep, idx) => {
                const parsed = parseLatLonFromUrl(dep.location);
                if (!parsed) return null;
                const { lat, lon } = parsed;
                return (
                  <Marker key={idx} position={[lat, lon]} eventHandlers={{
                    click: () => handleMapViewChange(lat, lon, 13)
                  }}>
                    <Popup>{dep.name}</Popup>
                  </Marker>
                );
              })}
            </MapContainer>
            </div>

         <div className="right-content">   
        <div className="search-box">
        <input
          type="text"
          placeholder="جستجوی نام شهر"
          value={searchTerm}
          onChange={handleSearchChange}
        />

            <div className="search-icon">
                <img src={searchIcon} alt="search"/>
            </div>
        </div>

         <div className="departments-list">
         {(isMobile ? filteredDepartments.slice(0, visibleCount) : filteredDepartments).map((dep, index) => (
                                <div
                                  className="department-item"
                                  key={index}
                                  role="button"
                                  tabIndex={0}
                                  onClick={() => copyDepartmentInfo(dep)}
                                  onKeyDown={(event) => {
                                    if (event.key === 'Enter' || event.key === ' ') {
                                      event.preventDefault();
                                      copyDepartmentInfo(dep);
                                    }
                                  }}
                                >
                                  <div className="department-first-row">
                                  <a
                                      href="#"
                                      onClick={(e) => {
                                        e.preventDefault();
                                        e.stopPropagation();
                                        const parsed = parseLatLonFromUrl(dep.location);
                                        if (parsed) {
                                          const { lat, lon } = parsed;
                                          // Update in-page map view - تغییر اصلی اینجاست
                                          handleMapViewChange(lat, lon, 13);
                                          
                                          // Open external map
                                          const userAgent = navigator.userAgent || navigator.vendor || window.opera;
                                          const isAndroid = /android/i.test(userAgent);
                                          const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
                                          if (isAndroid) {
                                            window.location.href = `geo:${lat},${lon}`;
                                          } else if (isIOS) {
                                            window.location.href = `https://maps.apple.com/?q=${lat},${lon}`;
                                          } else {
                                            window.open(`https://www.google.com/maps?q=${lat},${lon}`, '_blank', 'noopener,noreferrer');
                                          }
                                        }
                                      }}
                                     >
                                     نمایش آدرس در مسیریاب
                                    </a>
                                    <h6>{dep.name}</h6>

                                  </div>
                                  

                                    <div className="texts">
                                        <p>{dep.address}</p>
                                        <p
                                          className="phone-row"
                                          style={{marginTop:0}}
                                          onClick={(event) => event.stopPropagation()}
                                        >تلفن: <PhoneNumbers value={dep.phone} /></p>
                                        <p dir='rtl'>ساعت کاری: {formatWorkTime(dep.workTime)}</p>
                                    </div>
                                </div>
                            ))}
            </div>

{isMobile && visibleCount < filteredDepartments.length && (
  <div style={{ width: '100%', marginTop: '16px', display: 'flex', justifyContent: 'center' }}>
    <button
      onClick={() => setVisibleCount(prev => prev + 6)}
     className='show-more-button'
    >
      نمایش بیشتر
    </button>
  </div>
)}
      </div>
       </div>

</div>
<div ref={targetRef} id="faqTag"></div>
<div id="faq-list"></div>
               <FaqList hasTitle faqItems={faqItems} activeItems={activeItems} handleToggleFAQ={handleToggleFAQ} centralOffice={centralOffice} openChat={openChat} />

    {copyMessageVisible && <div className="copy-toast" role="status">کپی شد</div>}

    </div>
    <Footer/>
    </div>
  );
}

export default Contact;
